import React, { createContext, useContext, useEffect, useState } from "react";

const CityContext = createContext();

export const CityProvider = ({ children }) => {
  const [selectedCity, setSelectedCity] = useState(() => {
    const savedCity = localStorage.getItem("selectedCity");

    return savedCity ? JSON.parse(savedCity) : null;
  });

  useEffect(() => {
    if (selectedCity) {
      localStorage.setItem(
        "selectedCity",
        JSON.stringify(selectedCity)
      );
    } else {
      localStorage.removeItem("selectedCity");
    }
  }, [selectedCity]);

  const selectCity = (city) => {
    setSelectedCity(city);
  };

  const clearCity = () => {
    setSelectedCity(null);
  };

  return (
    <CityContext.Provider
      value={{
        selectedCity,
        selectCity,
        clearCity,
      }}
    >
      {children}
    </CityContext.Provider>
  );
};

export const useCity = () => {
  const context = useContext(CityContext);

  if (!context) {
    throw new Error("useCity must be used inside CityProvider");
  }

  return context;
};